
jQuery(function ($) {
    
    if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') {
        console.error('GSAP or ScrollTrigger not loaded');
        return;
    }
    
    gsap.registerPlugin(ScrollTrigger);
    gsap.registerPlugin(CustomEase);

    if ($('.wp-block-jormi-blocks-hero.hero-immersive').length) {
        // console.log('Immersive Hero on DOM');

        const $immersiveHero = $('.wp-block-jormi-blocks-hero.hero-immersive').first();
        const $container = $immersiveHero.find('.container');
        const $heading = $immersiveHero.find('h1');
        const $svg = $immersiveHero.find('svg');
        const $svgPaths = $svg.find('path');

        const $videoContainer = $immersiveHero.find('.video-container');
        const t = gsap.timeline({
            scrollTrigger: {
                trigger: $immersiveHero,
                scrub: 5,
                // pin: $container,
                start: "top top",
                end: () => `+=${window.innerHeight * 0.75}px`,
            }
        });

        // Heading Animation
        t.to($heading, {
            opacity: '0',
            // duration: 0.5,
            duration: 0.8,
            ease: "circ.in",
        }, 0);
        t.to($heading, {
            x: '5%',
            // duration: 0.5,
            duration: 0.8,
            ease: "circ.in",
        }, 0.1); // Start as soon as scroll starts

        // Video Position
        t.to($videoContainer, {
            left: '50%',
            x: '-50%',
            ease: 'none',
        }, 0);

        // Video width
        t.to($videoContainer, {
            width: '100%',
            // duration: 1.2,
            // ease: CustomEase.create("custom", "M0,0 C0.77,0 0.175,1 1,1"),
            duration: 2,
            ease: CustomEase.create("custom", "M0,0 C0.43,0 0.69,0.99 1,1")
        }, 0.1);

        // SVG Path Timelines
        t.to([$svgPaths.eq(0), $svgPaths.eq(1)], {
            x: '-100vw',
            // duration: 1.5,
            // ease: CustomEase.create("custom", "M0,0 C0.77,0 0.175,1 1,1"),
            duration: 3,
            ease: CustomEase.create("custom", "M0,0 C0.43,0 0.69,0.99 1,1")
        }, 0.1);
        t.to([$svgPaths.eq(2), $svgPaths.eq(3)], {
            x: '100vw',
            // duration: 1.5,
            // ease: CustomEase.create("custom", "M0,0 C0.77,0 0.175,1 1,1"),
            duration: 3,
            ease: CustomEase.create("custom", "M0,0 C0.43,0 0.69,0.99 1,1")
        }, 0.1);
    }

});